import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-collapsible',
    templateUrl: './collapsible.component.html',
    styleUrls: ['./collapsible.component.scss'],
    standalone: false
})
export class CollapsibleComponent implements OnInit {

    private _isOpen: boolean = true;

    public get isOpen(): boolean {
        return this._isOpen;
    }

    public set isOpen(value: boolean) {
        this._isOpen = value;
    }

    constructor() { }

    ngOnInit() {
    }

    public toggleOpen(): void {
        this._isOpen = !this._isOpen;
    }

}
